module.exports = __webpack_public_path__ + "static/img/ic_community_e.d23ffd8a.png";